import { render, staticRenderFns } from "./SubmissionsCardBoardsTab.vue?vue&type=template&id=602bc142&scoped=true&"
import script from "./SubmissionsCardBoardsTab.vue?vue&type=script&lang=ts&"
export * from "./SubmissionsCardBoardsTab.vue?vue&type=script&lang=ts&"
import style0 from "./SubmissionsCardBoardsTab.vue?vue&type=style&index=0&id=602bc142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602bc142",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
